import { FC } from 'react';

import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import styles from './styles.less';

const MainBackgroundIcon: FC = () => {
    const { profession } = useSelectorNonNullable((state) => state.pageProfession);

    return (
        <div
            className={styles.container}
            style={{ color: profession.icon.color }}
            dangerouslySetInnerHTML={{ __html: profession.icon.content }}
        />
    );
};

export default MainBackgroundIcon;
